module.exports = __webpack_public_path__ + "static/media/gallery-sidebar.7cae1081.jpg";